// extracted by mini-css-extract-plugin
export default {"row":"sEok2qbN2uB30xCB9RE5"};